// actions/PasswordAction.js
import axios from '../../utils/axios';
import { dispatch } from '../../store';
const API_URL = process.env.REACT_APP_LOCAL_API_URL


//reset password
export function resetPassword(payload, onSuccess, onError, onFinally) {
    return async () => {
        console.log('🔁 Reset Password Request Payload:', payload);

        try {
            const response = await axios.post(`${API_URL}resetpassword/reset-password`, payload);
            console.log('✅ API Response:', response.data);

            dispatch({
                type: 'RESET_PASSWORD',
                payload: {
                    data: response.data.data,
                    color: response.data.color
                }
            });

            console.log('📦 Dispatched RESET_PASSWORD with:', {
                data: response.data.data,
                color: response.data.color
            });

            if (onSuccess) {
                console.log('🎉 Calling onSuccess callback');
                onSuccess(response.data);
            }
        } catch (err) {
            const errorPayload = {
                data: err.response?.data?.data || 'Something went wrong',
                color: 'error'
            };

            console.error('❌ Reset password error:', errorPayload);

            dispatch({
                type: 'RESET_PASSWORD',
                payload: errorPayload
            });

            if (onError) {
                
                onError(errorPayload);
            }
        } finally {

            if (onFinally) {
                onFinally();
            }
        }
    };
}

//forgotpassword
export function forgetPassword(payload, onSuccess, onError, onFinally) {
    return async (dispatch) => {
        try {
            const response = await axios.post(`${API_URL}employeeregistrationform/forgetpassword`, payload);

            dispatch({
                type: 'FORGET_PASSWORD',
                payload: {
                    data: response.data.data,
                    color: response.data.color || 'success'
                }
            });

            if (onSuccess) onSuccess(response.data);
        } catch (err) {
            console.error('Forget password error:', err.response?.data || err.message);

            const errorPayload = {
                data: err.response?.data?.data || 'Something went wrong',
                color: 'error'
            };

            dispatch({
                type: 'FORGET_PASSWORD',
                payload: errorPayload
            });

            if (onError) onError(errorPayload);
        } finally {
            if (onFinally) onFinally();
        }
    };
}
